import { Affix, Button, Card, Spin } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getData, postData } from "../../../apiServices/common";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddPurchaseOrderForm from "./AddPurchaseOrderForm";

export default function ViewUnitsPrice(props) {
  const location = useLocation();
  let { styleId } = useParams();
  const { width } = props;
  const propertyFormRef = useRef(null);
  const [permitInfo, setPermitInfo] = useState();
  const [poDetailsData, setPoDetailsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const type = location.state?.type;

  const navigate = useNavigate();
  const discartForm = () => {
    navigate("/merchandising/style-wise-quantity-breakdown");
  };
  const edit_url = `/api/purchase_orders/${styleId}/edit`;

  // const getPOInfo = useCallback(async () => {
  //   const payload = {
  //     // style_ids: null,
  //     type: "preview",
  //   };
  //   let res = await postData(edit_url, payload);

  //   if (res) {
  //     let masterData = res.data;
  //     setPermitInfo(masterData);
  //     const po_data = masterData ? masterData?.purchase_order_details : null;

  //     const po_details = po_data?.map((item) => {
  //       const sizes = {};

  //       item?.sizes.forEach((size) => {
  //         sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
  //       });
  //       return {
  //         ...item,
  //         style_id: item.style.id,
  //         color_id: item.color.id,
  //         ...sizes,
  //       };
  //     });

  //     setPoDetailsData(po_details);
  //   }
  // }, [edit_url]);

  const getPOInfo = useCallback(
    async (styleIds = null) => {
      // const query = `/api/unit_prices/${itemId}/edit`;
      const payload = {};
      if (styleIds && styleIds.length > 0) {
        payload.style_ids = styleIds;
      }

      if (type) {
        payload.type = type;
      }

      let res = await postData(edit_url, payload);

      if (res) {
        let masterData = res.data;
        setPermitInfo(masterData);
        const po_data = masterData ? masterData?.purchase_order_details : null;

        const po_details = po_data?.map((item) => {
          const sizes = {};

          item?.sizes.forEach((size) => {
            sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
          });
          return {
            ...item,
            style_id: item.style.id,
            color_id: item.color.id,
            ...sizes,
          };
        });

        setPoDetailsData(po_details);
      }
      setIsLoading(false);
    },
    [edit_url],
  );

  useEffect(() => {
    getPOInfo();
  }, [getPOInfo]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="View Style Wise Quantity Breakdown"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Back
              </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <Spin spinning={isLoading} tip="Loading...">
        <AddPurchaseOrderForm
          ref={propertyFormRef}
          permitInfo={permitInfo}
          view={true}
          poDetailsData={poDetailsData}
          setPoDetailsData={setPoDetailsData}
          mode={"view"}
          getPOInfo={getPOInfo}
        />
      </Spin>
    </>
  );
}
